import { defineComponent as _defineComponent } from 'vue'
import { useUpdateTextMutation } from '~/types/types'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AutoCompleteTextInput',
  props: {
  userInput: {
    type: Object,
    default: () => ({}),
  },
  isEditable: {
    type: Boolean,
    default: false,
  },
  isMultiple: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const { mutate: updateText } = useUpdateTextMutation()

const value = computed(() => {
  const text = props.userInput.text
  if (!props.isMultiple) return text
  return text ? text.split(';') : []
})

function valueChange(val: any) {
  const values = props.isMultiple ? val.join(';') : val
  updateText({
    userInputId: props.userInput.id,
    text: values,
  })
}

return { __sfc: true,props, updateText, value, valueChange }
}

})